export enum GymFieldType {
  OPTIONS = 'OPTIONS',
  TRAINING_OPTIONS = 'TRAINING_OPTIONS', // legacy, kept for history
  MEMBERSHIP_TYPE = 'MEMBERSHIP_TYPE',
}
